<template>
    <h1>123456879</h1>
</template>

<script>
    export default {
        name: "Phone"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/about/contact/Phone.vue